<template>   
  <div class="searchPageAlt">
    <banner-search :oldSearchText = this.textPreviouslySearched></banner-search>
    <div class="content-holder bg-gradient-gray">
    <!-- {{showTrendingCards, showLibraryCards, showNewVideoCards}} -->
      <div class="">
        <searchCardsAlt></searchCardsAlt>
      </div>
      <section>
        <!-- <courseCards  v-if="isLoggedIn"></courseCards> -->
      </section>
      <section>
        <trendingCourses v-if ="showTrendingCards && ($store.getters.getSearchType == 'all' || $store.getters.getSearchType == 'CO')"></trendingCourses>
        <libraryCards v-if ="showTrendingCards && showLibraryCards && ($store.getters.getSearchType == 'all' || $store.getters.getSearchType == 'LO')"></libraryCards>
        <newVideoCards v-if ="showTrendingCards && showLibraryCards && showNewVideoCards && ($store.getters.getSearchType == 'all' || $store.getters.getSearchType == 'LO')"></newVideoCards>
        
      </section>
      <infinite-loading  v-if="continueScrolling" @infinite="infiniteHandler1 " spinner="waveDots" ref="infiniteLoader">
          <span slot ='no-results'></span>
          <span slot ='no-more'></span>
        </infinite-loading>
    </div>
    <!-- <footerArea></footerArea> -->
 </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus, gAnalysis } from '@/main.js'
import bannerSearch from '@/components/home/bannerSearch'
import searchCardsAlt from './searchCardsAlt'
import courseCards from '@/components/home/courseCards'
import libraryCards from '@/components/home/libraryCards'
import newVideoCards from '@/components/home/newVideoCards'
import loadercss from '@/components/searchPage/loadercss'
import trendingCourses from '@/components/home/trendingCourses.vue'
export default {
  name: 'searchPageAlt',
  components: {
    InfiniteLoading,
    bannerSearch,
    newVideoCards,
    courseCards,
    searchCardsAlt,
    libraryCards,
    loadercss,
    trendingCourses
  },
  data () {
    return {
      textPreviouslySearched: '',
      globalState: '',
      showTrendingCards: false,
      showLibraryCards: false,
      showNewVideoCards: false,
      continueScrolling: true
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  },
  // `created () {
  //   // alert(this.$route.params.search)
  // },`
  methods: {
    handleScroll () {
      if (this.showTrendingCards && !this.showLibraryCards) {
        // console.log('in if')
        setTimeout(() => {
          this.showLibraryCards = true
          // this.showSection = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            // this.globalState.complete()
            this.globalState.loaded()
          }
        }, 2000)
      } else if (this.showTrendingCards && this.showLibraryCards) {
        // console.log('in else')
        setTimeout(() => {
          this.showNewVideoCards = true
          // this.showSection = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 2000)
      }
      if (this.$store.getters.getSearchType === 'all') {
        if (this.showTrendingCards && this.showLibraryCards && this.showNewVideoCards) {
          this.continueScrolling = false
        }
      } else if (this.$store.getters.getSearchType === 'LO') {
        if (this.showLibraryCards && this.showNewVideoCards) {
          this.continueScrolling = false
        }
      } else if (this.$store.getters.getSearchType === 'CO') {
        if (this.showTrendingCards) {
          this.continueScrolling = false
        }
      }
    },
    infiniteHandler1   ($state) {
      // alert(123?)
      this.globalState = $state
      setTimeout(() => {
        this.showTrendingCards = true
        $state.loaded()
      }, 2000)
    },
    checkTokenValidity () {
      var home = this
      var token = window.MKCLAPI.getToken()
      if (token !== undefined && token !== null) {
        window.MKCLAPI.isTokenValid(token).then(function () {
          // token is valid
        }).catch(function () {
          home.$store.dispatch('clearUserData')
          window.MKCLAPI.removeToken()
        })
      }
    }
  },
  mounted () {
    gAnalysis()
    // var x1 = Math.floor(document.getElementById('searchBox').getBoundingClientRect().top)
    // var x2 = Math.floor(document.getElementById('example-text-input').getBoundingClientRect().top)
    // var displacement = Math.floor(document.getElementById('example-text-input').getBoundingClientRect().top) - ((x2 - x1) / 2)
    // window.scrollTo(0, displacement)
    EventBus.$emit('showNav', true)
  },
  created () {
    this.textPreviouslySearched = this.$route.params.search
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss">
.searchPageAlt{
.bg-gradient-gray{
       margin-top:-20px;
       padding-top:80px;
       background: linear-gradient(to bottom, #fafafa 50%,#ffffff 100%); 
    }
}
</style>




// WEBPACK FOOTER //
// src/components/searchPage/searchPageAlt.vue?50c0bb51